<template>
  <div class="full-height">
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <ForgotForm class="pb-16" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ForgotForm from "@/components/Forms/ForgotForm";
export default {
  components: { ForgotForm },
  name: "Forgot",
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<style lang="scss">
.full-height {
  display: flex;
  background-color: #f2f3f5;
  background-image: url("/assets/img/bg-login.svg");
  background-position: left top;
  background-size: auto;
  height: 100%;
  margin-top: -56px;
  width: 100%;
}
</style>
